module.exports = __webpack_public_path__ + "static/img/bushuli2.6099262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bushuli2.png
// module id = mZXF
// module chunks = 5